import {Directive, Input, OnChanges, OnInit} from "@angular/core";
import {NzTooltipDirective} from "ng-zorro-antd/tooltip";
import {SafeTooltipTemplateService} from "src/app/services/safe-tooltip-template.service";

// renders an HTML string as an ng-zorro tooltip. ng-zorro (like ng-bootstrap) escapes plain string
// content, so the markup is fed through a shared TemplateRef (registered by AppComponent) bound with
// [innerHTML] — Angular sanitizes it. NzTooltipDirective is attached as a host directive and
// configured imperatively, so the original safeTooltip / safeTooltipPlacement API is unchanged.
//
// ng-zorro is required here (not ng-bootstrap): the legacy Bootstrap 3 CSS forces `.tooltip{opacity:0}`,
// which hides the ngb tooltip window. ng-zorro renders under `.ant-tooltip`, so it is unaffected.
@Directive({
    selector: "[safeTooltip]",
    standalone: false,
    hostDirectives: [NzTooltipDirective]
})
export class SafeTooltipDirective implements OnInit, OnChanges {
    @Input("safeTooltip") tooltipContent: string;

    /**
     * The placement of the tooltip.
     * Valid values: top, left, bottom, or right.
     */
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("safeTooltipPlacement") tooltipPlacement: string;

    // stable context object whose $implicit holds the current HTML; the shared template renders it
    private readonly context = {$implicit: ""};

    constructor(
        private tooltip: NzTooltipDirective,
        private templates: SafeTooltipTemplateService
    ) {}

    ngOnInit() {
        // set before NzTooltipDirective's ngAfterViewInit syncs these to the overlay component
        this.tooltip.title = this.templates.content;
        this.tooltip.titleContext = this.context;
        this.tooltip.overlayClassName = "safe-tooltip";
        this.applyInputs();
    }

    ngOnChanges() {
        this.applyInputs();
    }

    private applyInputs() {
        this.context.$implicit = this.tooltipContent ?? "";
        this.tooltip.placement = this.tooltipPlacement ?? "top";
    }
}
